// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/SchoolWishList/Selected.less
// module id = 1621
// module chunks = 0